/* eslint-disable class-methods-use-this */

import BaseModel, { Thunk } from '@v4/utils/model/BaseModel'

class AIAssistantModel extends BaseModel {
	@Thunk
	fetchEditorAiContent() {}
}

export default AIAssistantModel
